export const SIZE_MAP = {
    short: 3,
    tall: 4,
};
